import { useEffect } from 'react'

import loadable from '@loadable/component'

import { Form } from '@tribeplatform/react-sdk/components'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { List } from '@tribeplatform/react-ui-kit/Layout'
import { useSlateComponent } from '@tribeplatform/slate-kit/hooks'

import { useTiptap } from '../../TipTap/hooks/useTiptap'
import { TiptapProvider } from '../../TipTap/TiptapProvider'

const Tiptap = loadable(() => import('../../TipTap'), {
  resolveComponent: module => module.Tiptap,
  ssr: false,
})

const Editor = () => {
  const { upsertProp } = useSlateComponent()
  const { editor } = useTiptap()

  const content = editor?.getHTML()

  useEffect(() => {
    upsertProp('content', content)

    // upsertProp changes on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content])

  return <Tiptap />
}

export const RichTextSettings = () => {
  const {
    component: { props },
    upsertProp,
  } = useSlateComponent()

  return (
    <Form defaultValues={props}>
      <List>
        <List.Item>
          <FormControl>
            <FormControl.Label>Content</FormControl.Label>
            <TiptapProvider content={props?.content}>
              <Editor />
            </TiptapProvider>
          </FormControl>
        </List.Item>
        <List.Item>
          <Form.Toggle
            label="Hidden"
            name="hidden"
            onChange={value => {
              upsertProp('hidden', value)
            }}
            checked={props?.hidden}
          />
        </List.Item>
      </List>
    </Form>
  )
}
